import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ServicesSections from '../../components/feature/ServicesSections';
import UpdatesSection from '../../components/feature/UpdatesSection';

export default function Services() {

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section
      className="relative h-96 flex items-end lg:pb-[70px] pb-0 lg:pl-[140px] pl-[0px] items-center lg:items-end lg:justify-start justify-center text-white"
      style={{
        backgroundImage: `linear-gradient(90deg, #022843 0%, rgba(2, 40, 67, 0) 100%), url('https://res.cloudinary.com/dpkn1ppzj/image/upload/v1770037658/225a0c135ced3784e064db51186047e752674e8f_f5tue6.png')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="relative z-10  px-6 lg:text-left text-center">
        <h1 className="text-3xl lg:text-[50px] font-medium mb-4">Our Services</h1>
      </div>
    </section>

      <ServicesSections />
      <UpdatesSection />
      <Footer />
    </div>
  );
}